<template>
  <div class="field">
    <div class="control">
      <input
        class="switch"
        :id="config.id"
        :name="config.id"
        type="checkbox"
        :checked="config.value"
        v-on:change="updateValue($event.target.value)"
      />

      <label :for="config.id">{{config.label}}</label>
    </div>
    <span class="label-error" v-if="config.error">{{config.message}}</span>
  </div>
</template>
<style  lang="scss" >
@import "./src/bulma/form/switch";
</style>
<script lang="ts">
// @ is an alias to /src
import { Component, Prop, Vue } from 'vue-property-decorator';

import { ISwitch } from './';

@Component({
  name: 'Toggle'
})
class Toggle extends Vue {
  @Prop({ required: true }) public config!: ISwitch;
  @Prop({ required: true }) public value!: string | number;
  public created() {}
  public updateValue(value: boolean) {
    this.config.value = !this.config.value;
    this.$emit('input', this.config.value);
    if (this.config.onClick) {
      this.config.onClick();
    }
  }
}
export default Toggle;
</script>